import React from 'react';
import styled from 'styled-components';

import Bullet from '../images/polaroid_pin.svg'

const Container = styled.div`
    width: 285px;
    background: white;
    box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.1);
    line-height: 1.75em;
    height: fit-content
    block-size: fit-content
`

const Pin = styled.img`
    display: block;
    position: relative;
    top: -44px;
    margin: auto;
    width: 40px;
    height: 45px;
`;

const Image = styled.img`
    display: block;
    width: 253px;
    height: 254px;
    box-sizing: border-box;
    margin: 0px 16px 13px 16px;
    z-index: 12;
    object-fit: cover;
`;

const Title = styled.a`
    display: block;
    font-family: 'Life Savers', cursive;
    font-size: 18px;
    font-weight: 400;
    color: black;
    text-align: left;   
    text-decoration: none;
    margin-left: 15px;
`

const ByLine = styled.div`
    display: block;
    font-family: 'Life Savers', cursive;
    font-size: 12px;
    font-weight: 400;
    color: black;
    text-align: left;
    margin-left: 15px;
`

export default function ArticleCard(props)
{

    return (
        <Container>
            <Pin src={Bullet}/>
            <a href={props.article_url}><Image src={props.article_image}/></a>
            <Title href={props.article_url}>{props.article_title}</Title>
            <ByLine> by {props.article_byline}</ByLine>
        </Container>
    )
}
